import { defineRecipe } from "@chakra-ui/react";

export const checkboxControlRecipe = defineRecipe({
  base: {
    cursor: "pointer",
    bg: "#fff",
    _checked: {
      bg: "link",
    },
    _indeterminate: {
      bg: "link",
    },
    _disabled: {
      bg: "#18181b",
    },
  },
  variants: {
    visual: {
      dark: {
        borderColor: "rgba(0, 0, 0, .5)",
      },
    },
  },
});

export const checkboxLabelRecipe = defineRecipe({
  base: {
    fontWeight: 600,
    fontSize: 16,
  },
  variants: {
    visual: {
      simple: {
        fontWeight: 400,
      },
    },
  },
});
